import { Text, VStack } from '@chakra-ui/react';
import type { ComponentProps } from 'react';

import { ADVISOR_PANEL_NEUTRAL_250 } from './advisor-panel-tokens';

/** Matches Figma — in-app AI agent legal disclaimer (AI Chat Modal Bottom). */
const AGENT_AI_DISCLAIMER_TEXT =
  "Responses are AI-generated. They don't replace advice from a qualified tax professional.";

/** Prefer importing as ``AgentAiDisclaimer`` from ``@kintsugi/advisor-ui`` in new code (same component). */
export function AdvisorAiDisclaimer(props: ComponentProps<typeof VStack>) {
  return (
    <VStack gap={0} align="stretch" {...props}>
      <Text
        fontSize="12px"
        fontWeight="normal"
        lineHeight="18px"
        color={ADVISOR_PANEL_NEUTRAL_250}
        textAlign="center"
        textWrap="balance"
      >
        {AGENT_AI_DISCLAIMER_TEXT}
      </Text>
    </VStack>
  );
}
